<div class="welcome-title-banner">
  <ng-container *ngIf="carrierLogo$ | async">
    <div class="image-box">
      <app-image class="logo" [src]="(carrierLogo$ | async) ?? ''"></app-image>
    </div>
  </ng-container>
  <h2 class="welcome-title mat-title-large">Attune questionnaire</h2>
</div>

<form *ngIf="formGroup" [formGroup]="formGroup">
  <emperor-text-input
    [formControlName]="AttuneComplianceQuestionKeys.YearsInBusiness"
    label="How long has your agency been in business?"
    type="number"
    [min]="0"
  ></emperor-text-input>

  <emperor-text-input
    [formControlName]="AttuneComplianceQuestionKeys.CommercialProducers"
    label="How many commercial producers are at your agency?"
    type="number"
    [min]="0"
  ></emperor-text-input>

  <emperor-masked-input
    [min]="0"
    [max]="100"
    placeholder="Enter percentage"
    [iconPrefix]="{ showPrefix: true, icon: 'percent_circle' }"
    label="What percentage of your commercial business consists of small business accounts?"
    [formControlName]="AttuneComplianceQuestionKeys.PercentageSmallBusiness"
    [mask]="percentageMask"
    hint="A business with an annual premium below $50k is considered a small business"
  ></emperor-masked-input>

  <emperor-select
    label="In which state do you write the most new business premium?"
    [choices]="stateChoices"
    [inputId]="'attune-new-business-premium'"
    [formControlName]="AttuneComplianceQuestionKeys.MostNewBusinessPremium"
  ></emperor-select>

  <emperor-select
    label="In which state do you write the second most new business premium?"
    [choices]="stateChoices"
    [inputId]="'attune-second-new-business-premium'"
    [formControlName]="
      AttuneComplianceQuestionKeys.SecondMostNewBusinessPremium
    "
  ></emperor-select>
</form>
